import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield } from 'lucide-react';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 3,
    seconds: 33
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 1;
          minutes = 3;
          seconds = 33;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-8 sm:py-10 px-4 bg-white border-y border-brand-gold/30 scroll-mt-10" data-id="element-133">
      <div className="max-w-2xl mx-auto" data-id="element-134">
        <div className="text-center mb-5" data-id="element-135">
          <p className="text-sm font-bold text-brand-gold uppercase tracking-wide mb-2" data-id="element-136">
            SPECIAL OFFER — COMPLETE 6-IN-1 SYSTEM
          </p>
          <p className="text-base text-brand-graphite/80 mb-3" data-id="element-137">
            Access the system now and transform your coaching today
          </p>
          <div className="inline-block bg-brand-petrol/10 border-2 border-brand-petrol px-4 py-1.5 rounded-lg" data-id="element-138">
            <p className="font-bold text-brand-petrol text-lg" data-id="element-139">
              FUNCTIONAL PRO™ 6-in-1 Complete System
            </p>
          </div>
        </div>

        <div className="bg-brand-cream border-4 border-brand-gold rounded-xl p-5 sm:p-6 text-center relative mb-5" data-id="element-140">
          <div className="mb-5" data-id="element-141">
            <p className="text-base text-brand-graphite/70 mb-1" data-id="element-142">
              Normal Price: <span className="line-through" data-id="element-143">$97 USD</span>
            </p>
            <p className="text-lg font-bold text-red-600 mb-3" data-id="element-144">
              72% OFF — LAUNCH OFFER
            </p>
            <p className="text-sm text-brand-graphite/70 mb-2" data-id="element-145">
              Limited Time Price:
            </p>
            <p className="text-5xl font-serif font-bold text-brand-petrol mb-2" data-id="element-146">
              $27 USD
            </p>
            <p className="text-sm text-brand-graphite/70" data-id="element-147">
              Pay in your local currency
            </p>
          </div>

          <div className="bg-red-50 border-2 border-red-300 rounded-lg p-4 mb-6" data-id="element-148">
            <p className="text-sm font-bold text-red-600 mb-3" data-id="element-149">
              🔥 Last chance! The price increases when the timer ends.
            </p>
            <div className="flex justify-center gap-4" data-id="element-150">
              <div className="text-center" data-id="element-151">
                <div className="bg-brand-petrol text-white text-2xl font-bold px-4 py-2 rounded" data-id="element-152">
                  {String(timeLeft.hours).padStart(2, '0')}
                </div>
                <p className="text-xs text-brand-graphite/70 mt-1" data-id="element-153">HOURS</p>
              </div>
              <div className="text-center" data-id="element-154">
                <div className="bg-brand-petrol text-white text-2xl font-bold px-4 py-2 rounded" data-id="element-155">
                  {String(timeLeft.minutes).padStart(2, '0')}
                </div>
                <p className="text-xs text-brand-graphite/70 mt-1" data-id="element-156">MINUTES</p>
              </div>
              <div className="text-center" data-id="element-157">
                <div className="bg-brand-petrol text-white text-2xl font-bold px-4 py-2 rounded" data-id="element-158">
                  {String(timeLeft.seconds).padStart(2, '0')}
                </div>
                <p className="text-xs text-brand-graphite/70 mt-1" data-id="element-159">SECONDS</p>
              </div>
            </div>
          </div>

          <CTAButton href="https://functionalpro.impultienda.ar/checkout" data-id="element-160">
            🚀 YES, I WANT THE COMPLETE SYSTEM ($27)
          </CTAButton>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm text-brand-graphite/70" data-id="element-161">
          <div className="flex items-center gap-1" data-id="element-162">
            <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-163" />
            <span className="font-semibold" data-id="element-164">4.9/5 — Verified Reviews</span>
          </div>
          <span className="hidden sm:inline" data-id="element-165">•</span>
          <div className="flex items-center gap-1" data-id="element-166">
            <Shield className="w-4 h-4 text-brand-petrol" data-id="element-167" />
            <span className="font-semibold" data-id="element-168">7-Day Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}